<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<!-- <a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button> -->
				<a-button icon="sync" @click="apiInventoryQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="库存查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId" @change="facilitatorChange">
							<a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">产品名称：</div>
						<a-select v-model="query.productId" @change="producChange">
							<a-select-option v-for="(item, index) in productList" :key="index" :value="item.productId">{{item.productName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">选择价格：</div>
						<a-select v-model="query.priceId">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in priceList" :key="index" :value="item.priceId">{{item.listingPrice / 100}}</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiInventoryQueryList">查询</a-button>
					<a-button icon="redo" @click="apiOrdersQueryList" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="inventoryId" :loading="tableLoading" :pagination="false">
				<span slot="inventoryName" slot-scope="inventoryName">
					<a-button type="link" @click="edit(inventoryName)" >{{inventoryName.inventoryName}}</a-button>
				</span>
				<span slot="listingPrice" slot-scope="listingPrice">
					{{listingPrice / 100}}
				</span>
				<span slot="inventoryType" slot-scope="inventoryType">
					<!-- <span v-if="inventoryType == 2">小时库存</span> -->
					<span v-if="inventoryType == 3">小时库存(区间)</span>
					<span v-if="inventoryType == 4">日库存</span>
					<span v-if="inventoryType == 5">日库存(区间)</span>
				</span>
				<span slot="inventoryState" slot-scope="inventoryState">
					<span v-if="inventoryState == 2">禁用</span>
					<span v-if="inventoryState == 3">启用</span>
					<span v-if="inventoryState == 5">失效</span>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal class="qa-modal-half" title="添加" width="1000px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<div class="qa-table-item-2">
					<a-form-model-item label="库存名称" has-feedback prop="inventoryName">
						<a-input v-model="addForm.inventoryName" placeholder="请输入库存名称" />
					</a-form-model-item>
					<a-form-model-item label="是否启用" has-feedback prop="inventoryState">
						<a-radio-group name="inventoryState" v-model="addForm.inventoryState">
							<a-radio :value="3">是</a-radio>
							<a-radio :value="2">否</a-radio>
						</a-radio-group>
					</a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
						<a-select v-model="query.facilitatorId" @change="facilitatorChange">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item label="产品名称" has-feedback prop="productId">
						<a-select v-model="query.productId" @change="producChange">
							<a-select-option v-for="(item, index) in productList" :key="index" :value="item.productId">{{item.productName}}</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item label="选择价格" has-feedback prop="priceId">
						<a-select v-model="query.priceId">
							<a-select-option :value="0">请选择</a-select-option>
							<a-select-option v-for="(item, index) in priceList" :key="index" :value="item.priceId">{{item.listingPrice / 100}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="库存类型" has-feedback prop="inventoryType">
						<a-select v-model="addForm.inventoryType">
							<!-- <a-select-option :value="2">小时库存</a-select-option> -->
							<a-select-option :value="3">小时库存(区间)</a-select-option>
							<a-select-option :value="4">日库存</a-select-option>
							<a-select-option :value="5">日库存(区间)</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item></a-form-model-item>
					<a-form-model-item></a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="库存总数" has-feedback prop="inventoryTotal">
						<a-input v-model="addForm.inventoryTotal" placeholder="请输入库存数量" />
					</a-form-model-item>
					<a-form-model-item></a-form-model-item>
					<a-form-model-item></a-form-model-item>
			
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="开始日期" has-feedback prop="startDate">
						<a-date-picker v-model="addForm.startDate" format="YYYY-MM-DD"/>
					</a-form-model-item>
					<a-form-model-item label="结束日期" has-feedback prop="endDate">
						<a-date-picker v-model="addForm.endDate" format="YYYY-MM-DD"/>
					</a-form-model-item>
					<a-form-model-item></a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="开始时间" has-feedback prop="startTime">
						<a-time-picker v-model="addForm.startTime" format="HH:mm:ss" />
					</a-form-model-item>
					<a-form-model-item label="结束时间" has-feedback prop="endTime">
						<a-time-picker v-model="addForm.endTime" format="HH:mm:ss" />
					</a-form-model-item>
					<a-form-model-item>
					</a-form-model-item>
				</div>
			</a-form-model>
			
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-half" title="修改" width="1000px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<div class="qa-table-item-2">
					<a-form-model-item label="库存名称" has-feedback prop="inventoryName">
						<a-input v-model="editForm.inventoryName" placeholder="请输入库存名称" />
					</a-form-model-item>
					<a-form-model-item label="是否启用" has-feedback prop="inventoryState">
						<a-radio-group name="inventoryState" v-model="editForm.inventoryState">
							<a-radio :value="3">是</a-radio>
							<a-radio :value="2">否</a-radio>
						</a-radio-group>
					</a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
						<a-select v-model="editForm.facilitatorId" @change="facilitatorChange" disabled>
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item label="产品名称" has-feedback prop="productId">
						<a-select v-model="editForm.productId" @change="producChange" disabled>
							<a-select-option v-for="(item, index) in productList" :key="index" :value="item.productId">{{item.productName}}</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item label="选择价格" has-feedback prop="priceId">
						<a-select v-model="editForm.priceId" disabled>
							<a-select-option :value="0">请选择</a-select-option>
							<a-select-option v-for="(item, index) in priceList" :key="index" :value="item.priceId">{{item.listingPrice / 100}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="库存类型" has-feedback prop="inventoryType">
						<a-select v-model="editForm.inventoryType">
							<!-- <a-select-option :value="2">小时库存</a-select-option> -->
							<a-select-option :value="3">小时库存(区间)</a-select-option>
							<a-select-option :value="4">日库存</a-select-option>
							<a-select-option :value="5">日库存(区间)</a-select-option>
						</a-select>
					</a-form-model-item>
					<a-form-model-item></a-form-model-item>
					<a-form-model-item></a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="库存总数" has-feedback prop="inventoryTotal">
						<a-input v-model="editForm.inventoryTotal" placeholder="请输入库存数量" />
					</a-form-model-item>
					<a-form-model-item></a-form-model-item>
					<a-form-model-item></a-form-model-item>
							
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="开始日期" has-feedback prop="startDate">
						<a-date-picker v-model="editForm.startDate" format="YYYY-MM-DD"/>
					</a-form-model-item>
					<a-form-model-item label="结束日期" has-feedback prop="endDate">
						<a-date-picker v-model="editForm.endDate" format="YYYY-MM-DD"/>
					</a-form-model-item>
					<a-form-model-item></a-form-model-item>
				</div>
				<div class="qa-table-item-3">
					<a-form-model-item label="开始时间" has-feedback prop="startTime">
						<a-time-picker v-model="editForm.startTime" format="HH:mm:ss" />
					</a-form-model-item>
					<a-form-model-item label="结束时间" has-feedback prop="endTime">
						<a-time-picker v-model="editForm.endTime" format="HH:mm:ss" />
					</a-form-model-item>
					<a-form-model-item>
					</a-form-model-item>
				</div>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				productList: [],
				priceList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 0,
					productId: 0,
					priceId: 0,
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', key:'inventoryId', dataIndex:'inventoryId', align:'center'},
					{ title:'库存名称', key:'inventoryName', align:'center', scopedSlots:{customRender:'inventoryName'}},
					{ title:'服务商', key:'facilitatorName', dataIndex:'facilitatorName', align:'center'},
					{ title:'产品名称', key:'productName', dataIndex:'productName', align:'center'},
					{ title:'价格', key:'listingPrice', dataIndex:'listingPrice', align:'center', scopedSlots:{customRender:'listingPrice'}},
					{ title:'库存类型', key:'inventoryType', dataIndex:'inventoryType', align:'center', scopedSlots:{customRender:'inventoryType'}},
					{ title:'开始日期', key:'startDate', dataIndex:'startDate', align:'center'},
					{ title:'结束日期', key:'endDate', dataIndex:'endDate', align:'center'},
					{ title:'开始时间', key:'startTime', dataIndex:'startTime', align:'center'},
					{ title:'结束时间', key:'endTime', dataIndex:'endTime', align:'center'},
					{ title:'状态', key:'inventoryState', dataIndex:'inventoryState', align:'center', scopedSlots:{customRender:'inventoryState'}},
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: 0,
					productId: 0,
					priceId: 0,
					inventoryName: '',
					inventoryType: 3,
					startDate: '',
					endDate: '',
					startTime: '',
					endTime: '',
					inventoryTotal: '',
					inventoryState: 3,
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					inventoryName: [{ required: true, message: '库存名称不能为空', trigger: 'blur' }],
					inventoryState: [{ required: true, message: '请选择', trigger: 'blur' }],
					productId: [{ required: true, message: '请选择', trigger: 'blur' }],
					priceId: [{ required: true, message: '请选择', trigger: 'blur' }],
					inventoryType: [{ required: true, message: '请选择', trigger: 'blur' }],
					inventoryTotal: [{ required: true, message: '请输入', trigger: 'blur' }],
					startDate: [{ required: true, message: '请输入', trigger: 'blur' }],
					endDate: [{ required: true, message: '请输入', trigger: 'blur' }],
					startTime: [{ required: true, message: '请输入', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					inventoryId: '',
					facilitatorId: 0,
					productId: 0,
					priceId: 0,
					inventoryName: '',
					inventoryType: 3,
					startDate: '',
					endDate: '',
					startTime: '',
					endTime: '',
					inventoryTotal: '',
					inventoryState: 3,
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,this.query);
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.mainNavigation[0] = res.data[0]
					this.apiProductList()
					this.apiInventoryQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取产品列表
			async apiProductList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductList, {facilitatorId: this.query.facilitatorId});
				if (res.code == 200) {
					this.query.productId = ''
					this.productList = res.data
					this.query.productId = res.data[0].productId
					this.apiPriceList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取价格列表
			async apiPriceList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceList, {productId: this.query.productId});
				if (res.code == 200) {
					this.priceList = res.data
					this.query.priceId = 0
				} else {
					this.$message.error(res.msg)
				}
			},
			
			//获取产品列表
			facilitatorChange(e) {
				this.priceList = []
				this.query.priceId = 0
				this.apiProductList()
			},
			producChange(e) {
				this.apiPriceList()
			},
			
			//重置
			apiOrdersQueryList() {
				this.apiFacilitatorList()
			},

			//表格开始-搜索
			async apiInventoryQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiInventoryQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiInventoryQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiInventoryQueryList()
			},
			async apiInventoryAdd() {
				this.addConfirmLoading = true
				let data = JSON.parse(JSON.stringify(this.addForm))
				data.facilitatorId = this.query.facilitatorId
				data.productId = this.query.productId
				data.priceId = this.query.priceId
				data.startDate = this.addForm.startDate.format('YYYY-MM-DD')
				data.endDate = this.addForm.endDate.format('YYYY-MM-DD')
				data.startTime = this.addForm.startTime.format('HH:mm:ss')
				data.endTime = this.addForm.endTime.format('HH:mm:ss')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiInventoryAdd, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiInventoryQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiInventoryAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				items.startDate = this.moment(item.startDate)
				items.endDate = this.moment(item.endDate)
				items.startTime = this.moment(item.startTime, 'HH:mm:ss')
				items.endTime = this.moment(item.endTime, 'HH:mm:ss')
				this.editForm = items
				this.editVisible = true
			},
			async apiInventoryEdit() {
				let data = JSON.parse(JSON.stringify(this.editForm))
				data.startDate = this.moment(data.startDate).format('YYYY-MM-DD')
				data.endDate = this.moment(data.endDate).format('YYYY-MM-DD')
				data.startTime = this.moment(data.startTime).format('HH:mm:ss')
				data.endTime = this.moment(data.endTime).format('HH:mm:ss')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiInventoryEdit, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiInventoryQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiInventoryEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.inventoryId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.inventoryName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiTicketstationDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiTicketstationDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationDel, {inventoryId: this.tableSelectedRows.inventoryId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiInventoryQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.inventoryId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
